"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Button.scss");
var classnames_1 = __importDefault(require("classnames"));
var Spinner_1 = __importDefault(require("../Spinner"));
var ButtonType;
(function (ButtonType) {
    ButtonType["button"] = "button";
    ButtonType["submit"] = "submit";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
var Button = function (props) {
    var onClick = props.onClick, form = props.form, id = props.id, _a = props.processing, processing = _a === void 0 ? false : _a, children = props.children, dusk = props.dusk, disabled = props.disabled, _b = props.type, type = _b === void 0 ? ButtonType.button : _b, className = props.className, _c = props.size, size = _c === void 0 ? 'base' : _c;
    return (react_1.default.createElement("button", { id: id, form: form, type: type, disabled: disabled || processing, "data-dusk": dusk, className: classnames_1.default('button', "button--" + size, className), onClick: onClick },
        children,
        processing && react_1.default.createElement(Spinner_1.default, null)));
};
exports.default = Button;
//# sourceMappingURL=Button.js.map